export default "__VITE_ASSET__6YeAIAZf__"